import {NgModule} from "@angular/core";
import {BrowserChooserComponent} from "./browserchooser.component";
import {CommonModule} from "@angular/common";
import {BrowserComponent} from "./browser.component";
import {BrowsersInfoComponent} from "./browsers-info.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {TooltipModule} from "primeng/tooltip";

@NgModule({
  declarations: [
      BrowserChooserComponent,
      BrowserComponent,
      BrowsersInfoComponent
  ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        TooltipModule
    ],
  exports: [
      BrowserChooserComponent,
      BrowserComponent,
      BrowsersInfoComponent
  ]
})
export class WebmateBrowserModule {
}
